var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-view"},[(_vm.editable)?_vm._t("default",[_c('el-form-item',[_c('el-input',{attrs:{"value":_vm.data,"placeholder":_vm.placeholder},on:{"input":_vm.updateParent}})],1)]):_c('span',[_vm._v("\n    "+_vm._s(_vm.data)+"\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644260e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submission/steps/CollaboratorDetails/CollaboratorItem/EditView.vue
// module id = 558
// module chunks = 0 1 2 3 9